import type { UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';
import type { UseMutationResult } from 'react-query';
import type { ApiResponse } from '../../../util/types/Response';
import type { GroupDto } from '../types/GroupDto';

export function useServerGroupValidation<T>(
	newGroupMutation: UseMutationResult<
		ApiResponse<GroupDto>,
		unknown,
		void,
		unknown
	>,
	form: UseFormReturnType<T, (values: T) => T>,
) {
	useEffect(() => {
		if (!newGroupMutation.data?.isValid) {
			newGroupMutation.data?.validationMessages.forEach((v) => {
				if (v.inputIdentifier === 'GroupName') {
					form.setErrors({ groupName: v.validationMessage });
				}
			});
		}
	}, [newGroupMutation.data?.validationMessages]);
}
